'use client';

import React__default, { useContext, useEffect } from 'react';
import { DropdownBodyWrapper } from './DropdownBody.css.js';
import LeftColumnContent from './components/LeftColumnContent/index.js';
import RightColumnContent from './components/RightColumnContent/index.js';
import { CascaderContext } from '../../context/reducer.js';
import ResponsiveBody from './components/ResponsiveBody/index.js';
import { ACTIONS } from '../../context/actions.js';

var DropdownBody = function () {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, dispatch = _a.dispatch;
    var isMobile = props.isMobile, selectOptions = props.selectOptions;
    var isShow = state.isShow, temporaryValue = state.temporaryValue;
    var onMouseLeave = function () {
        dispatch({
            type: ACTIONS.SET_MOUSE_LEAVE
        });
    };
    useEffect(function () {
        if (!isShow || !isMobile) {
            return;
        }
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = 'initial';
        };
    }, [isShow, isMobile]);
    return (React__default.createElement(DropdownBodyWrapper, { "data-cname": 'dropdown__body', isMobile: isMobile, isHaveItem: temporaryValue.length > 0, isSingleSelect: selectOptions.isSingleSelect, onMouseLeave: onMouseLeave }, isMobile ? (React__default.createElement(ResponsiveBody, null)) : (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(LeftColumnContent, null),
        React__default.createElement(RightColumnContent, null)))));
};

export { DropdownBody as default };
//# sourceMappingURL=index.js.map
